var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"column":""}},[_c('v-toolbar',{staticClass:"header-list"},[_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }